
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class OnBeforeUnload extends Vue {

    mounted() {
        window.onbeforeunload = () => 'You have unsaved changes!'
    }

    beforeDestroy() {
        return (window.onbeforeunload = null)
    }

    beforeLeave(to: any, from: any, next: any) {
        return window.confirm('Do you really want to leave? You have unsaved changes!') ? next() : next(false)
    }
}
